<template>
  <div id="app">
    <SplashScreen />
    <nav
      class="navbar is-hidden-print"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <a class="navbar-item navbar-item__logo">
          <img src="img/icons/android-chrome-192x192.png" alt="Meal Planner" />
        </a>
        <router-link
          to="/recipes"
          class="navbar-item navbar-item__recipes is-tab is-hidden-touch"
          exact-active-class="is-active"
        >
          <a>{{ $t("Recipes") }}</a>
        </router-link>
        <router-link
          to="/plan"
          class="navbar-item navbar-item__plan is-tab"
          exact-active-class="is-active"
        >
          <a>{{ $t("Plan") }}</a>
        </router-link>
        <router-link
          to="/list"
          class="navbar-item navbar-item__list is-tab"
          exact-active-class="is-active"
        >
          <a>{{ $t("Shopping List") }}</a>
        </router-link>
        <router-link
          to="/settings"
          class="navbar-item navbar-item__settings is-tab is-hidden-touch"
          exact-active-class="is-active"
        >
          <a>{{ $t("Settings") }}</a>
        </router-link>
        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          @click="toggleNavbarMenu"
          v-bind:class="{ 'is-active': showNavBarMenu }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div
        class="navbar-menu is-hidden-desktop"
        v-bind:class="{ 'is-active': showNavBarMenu }"
      >
        <div class="navbar-start">
          <router-link
            to="/recipes"
            class="navbar-item navbar-item__recipes"
            exact-active-class="is-active"
          >
            <a>{{ $t("Recipes") }}</a>
          </router-link>
          <router-link
            to="/plan"
            class="navbar-item navbar-item__plan"
            exact-active-class="is-active"
          >
            <a>{{ $t("Plan") }}</a>
          </router-link>
          <router-link
            to="/list"
            class="navbar-item navbar-item__list"
            exact-active-class="is-active"
          >
            <a>{{ $t("Shopping List") }}</a>
          </router-link>
          <router-link
            to="/settings"
            class="navbar-item navbar-item__settings"
            exact-active-class="is-active"
          >
            <a>{{ $t("Settings") }}</a>
          </router-link>
        </div>
      </div>
    </nav>

    <div class="container main-container">
      <router-view />
    </div>

    <footer-nav />
  </div>
</template>
<script>
import Vue from "vue";
import SplashScreen from "@/components/SplashScreen.vue";
import FooterNav from "@/components/FooterNav.vue";

export default Vue.extend({
  name: "app",
  data: function () {
    return { showNavBarMenu: false };
  },
  created() {
    this.$router.afterEach(() => {
      this.showNavBarMenu = false;
    });
  },
  methods: {
    toggleNavbarMenu() {
      this.showNavBarMenu = !this.showNavBarMenu;
    },
  },
  components: {
    SplashScreen,
    FooterNav,
  },
});
</script>
<style>
div.main-container {
  margin-bottom: 1.5rem;
  padding: 0 1rem;
}

.navbar,
.navbar-menu {
  margin-bottom: 1.5rem;
}

@media print {
  body .container {
    font-family: "Palatino Linotype", Palatino, Palladio, "URW Palladio L",
      "Book Antiqua", Baskerville, "Bookman Old Style", "Bitstream Charter",
      "Nimbus Roman No9 L", Garamond, "Apple Garamond", "ITC Garamond Narrow",
      "New Century Schoolbook", "Century Schoolbook", "Century Schoolbook L",
      Georgia, serif;
  }

  .is-hidden-print {
    display: none !important;
  }
}
</style>
<i18n>
{
  "en": {
    "addPhoto": "Add photo"
  },
  "de": {
    "Add new recipe": "Rezept hinzufügen",
    "Add your favorite recipes here.": "Trage hier deine Lieblingsrezepte ein.",
    "Keep it simple: you don't need exact amounts or instructions. Just a list of ingredients that should go on your shopping list.": "Du brauchst keine Mengenangaben. Einfach nur die Dinge, die auf deinen Einkaufszettel gehören.",
    "recipeImage": "Ein Bild des Rezepts",
    "addPhoto": "Foto hinzufügen"
  }
}
</i18n>
